import Vuetify from "@/plugins/vuetify";
import _ from "lodash";

const goalStatusTypes = {
  getGoalStatusTypeColor(id) {
    let color = Vuetify.framework.theme.themes.light.success;
    switch (id) {
      case this.$enums.goalStatusTypes.ON_TRACK:
        color = Vuetify.framework.theme.themes.light.info;
        break;
      case this.$enums.goalStatusTypes.OFF_TRACK:
        color = Vuetify.framework.theme.themes.light.error;
        break;
      case this.$enums.goalStatusTypes.PAUSED:
        color = Vuetify.framework.theme.themes.light.secondarytext;
        break;
    }
    return color;
  },
  getGoalStatusTypeIcon(id) {
    let icon = "done";
    switch (id) {
      case this.$enums.goalStatusTypes.ON_TRACK:
        icon = "trending_up";
        break;
      case this.$enums.goalStatusTypes.OFF_TRACK:
        icon = "trending_down";
        break;
      case this.$enums.goalStatusTypes.PAUSED:
        icon = "pause";
        break;
    }
    return icon;
  },
  sortGoalStatuses(statuses) {
    let self = this;
    return _.sortBy(statuses, function(o) {
      let id = o.statusId || o.id;
      return self.$enums.goalStatusTypes.COMPLETED == id ? 0 : id;
    });
  }
};

export default { methods: goalStatusTypes };
